// 13 provinces et territoires canadiens, codes ISO 3166-2:CA
// Triés par ordre francophone d'affichage (QC en premier car contexte legal québécois)
export const PROVINCES_CA = [
    { code: "QC", nom: "Québec" },
    { code: "ON", nom: "Ontario" },
    { code: "NB", nom: "Nouveau-Brunswick" },
    { code: "NS", nom: "Nouvelle-Écosse" },
    { code: "PE", nom: "Île-du-Prince-Édouard" },
    { code: "NL", nom: "Terre-Neuve-et-Labrador" },
    { code: "MB", nom: "Manitoba" },
    { code: "SK", nom: "Saskatchewan" },
    { code: "AB", nom: "Alberta" },
    { code: "BC", nom: "Colombie-Britannique" },
    { code: "YT", nom: "Yukon" },
    { code: "NT", nom: "Territoires du Nord-Ouest" },
    { code: "NU", nom: "Nunavut" },
];
